import React, { Component, Fragment } from 'react'

class SubmitCheck extends Component {
    render() {
        const {openSuccess, success, openErrors} = this.props;
        return (
            <Fragment>
                <div className={`overlay ${openSuccess ? 'show' : ''}`} />
                {
                openSuccess &&
                <div className="successBox fade">
                    <div className={`title ${openErrors ? 'errors' : ''}`}>
                    <i className="fas fa-exclamation-triangle" /> {openErrors ? 'Có lỗi xảy ra' : 'Xác thực thành công'}
                    </div>
                    <div className={`content ${openErrors ? 'errors' : ''}`}>
                    <p className={`fade ${success.domain ? 'active' : ''}`}>{success.domain ? <i className="fal fa-check-circle" /> : <i className="fal fa-times-circle" />} {success.domain ? 'Xác thực Tên miền thành công.' : 'Vui lòng lựa chọn Tên miền.'}</p>
                    <p className={`fade ${success.title_vi ? 'active' : ''}`}>{success.title_vi ? <i className="fal fa-check-circle" /> : <i className="fal fa-times-circle" />} {success.title_vi ? 'Xác thực Tiêu đề thành công.' : 'Vui lòng nhập Tiêu đề.'}</p>
                    <p className={`fade ${success.slug ? 'active' : ''}`}>{success.slug ? <i className="fal fa-check-circle" /> : <i className="fal fa-times-circle" />} {success.slug ? 'Xác thực Đường dẫn thành công.' : 'Vui lòng nhập Đường dẫn.'}</p>
                    <p className={`fade ${success.description_vi ? 'active' : ''}`}>{success.description_vi ? <i className="fal fa-check-circle" /> : <i className="fal fa-times-circle" />} {success.description_vi ? 'Xác thực Mô tả dài thành công.' : 'Vui lòng nhập Mô tả dài.'}</p>
                    <p className={`fade ${success.categories ? 'active' : ''}`}>{success.categories ? <i className="fal fa-check-circle" /> : <i className="fal fa-times-circle" />} {success.categories ? 'Xác thực Danh mục thành công.' : 'Vui lòng lựa chọn Danh mục.'}</p>
                    <p className={`fade ${success.featuredImg ? 'active' : ''}`}>{success.featuredImg ? <i className="fal fa-check-circle" /> : <i className="fal fa-times-circle" />} {success.featuredImg ? 'Xác thực Ảnh đại diện thành công.' : 'Vui lòng chỉ định Ảnh đại diện.'}</p>
                    </div>
                    {openErrors ?
                    <div className="action-group">
                        <div className="btn-errors" onClick={this.props.cancelPublic}>Kiểm tra lại</div>
                    </div>
                    :
                    <div className="action-group">
                        <div className="btn-confirm" onClick={this.props.sendData}>Đồng ý</div>
                        <div className="btn-cancel" onClick={this.props.cancelPublic}>Huỷ bỏ</div>
                    </div>
                    }
                </div>
                }
            </Fragment>
        )
    }
}

export default SubmitCheck
